import EventEdit from './EventEdit';

export default EventEdit;
